import { Picker } from "emoji-mart";
import "emoji-mart/css/emoji-mart.css";
import parse from "html-react-parser";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { firebase } from "../constants/firebase";
import { UserContext } from "../containers/UserProvider";
import { CommentActions } from "./CommentActions";
import { CreateComment } from "./CreateComment";
import { EmojiContainer } from "./EmojiContainer";
import { OutsideClickAlerter } from "./OutsideClickAlerter";
import { ReplyList } from "./ReplyList";

export const Comment = ({ comment, setInputProps, thread }) => {
  const [commentAuthor, setCommentAuthor] = useState(null);
  const [replyListOpen, setReplyListOpen] = useState(true);
  const [replyOpen, setReplyOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [showEmojiMart, setShowEmojiMart] = useState(false);
  const db = firebase.firestore();

  const currUser = useContext(UserContext);

  const { user, text, updatedAt, id, replies } = comment;

  const path = `comments/${id}/emojis`;
  // : `replies/${replyId}/emojis`;

  useEffect(() => {
    if (!commentAuthor) {
      const getData = async () => {
        const authorDoc = await user.get();
        setCommentAuthor(authorDoc.data());
      };
      getData();
    }
  }, [commentAuthor]);

  useEffect(() => {
    if (replyOpen) {
      setInputProps({
        isReply: replyOpen,
        cancelHandler: () => {
          setReplyOpen(false);
        },
        commentId: id,
        subtitle: `Replying to @${commentAuthor.username}`,
      });
    } else {
      setInputProps({
        isReply: replyOpen,
        commentId: null,
        subtitle: null,
      });
    }
  }, [replyOpen]);

  const addEmoji = (e) => {
    db.collection(path)
      .doc(e.colons)
      .set({
        voteCount: 1,
        voters: [db.doc(`users/${currUser.uid}`)],
        unicode: e.native,
      });
  };

  if (!user) {
    return <div> No User</div>;
  }

  if (!commentAuthor) {
    return <div />;
  }

  return (
    <div>
      <div className="bg-gray-700 bg-opacity-100 dark:bg-gray-800 rounded-md">
        <div className="px-4 pt-4 mb-2">
          <div className="flex content-start mb-2">
            {/* <div className="flex-none block relative mt-2">
              
            </div> */}
            <div className="w-full">
              <div className="flex mb-1">
                <div className="flex-none flex  items-center">
                  <img
                    alt="profile"
                    src={
                      commentAuthor.imageUrl ||
                      "https://qph.fs.quoracdn.net/main-qimg-2b21b9dd05c757fe30231fac65b504dd"
                    }
                    className="mx-auto object-cover rounded-full h-5 w-5 mr-2"
                  />
                  <span className="font-semibold flex items-center text-blue-400 text-sm">
                    {commentAuthor.username}
                  </span>
                  <span className="w-1 h-1 rounded-full bg-gray-400 mx-1" />
                  <span className="text-gray-400 text-xs flex items-center">
                    {moment(updatedAt.toDate()).fromNow()}
                  </span>
                </div>
                <div className="flex-grow"> </div>
                <div className="relative flex-none">
                {!!currUser && (
                  <CommentActions
                    myPost={currUser?.id === user.id}
                    commentId={id}
                    setEditMode={setEditMode}
                  />
                )}
                </div>
              </div>

              {editMode ? (
                <CreateComment
                  prefilledText={text}
                  commentId={id}
                  closeEditMode={() => setEditMode(false)}
                  editMode
                  inputProps={{
                    isReply: false,
                    commentId: id,
                    subtitle: "Editing this post...",
                    cancelHandler: () => setEditMode(false),
                  }}
                  thread={thread}
                />
              ) : (
                <div className="text-white dark:text-white mb-2 text-left">
                  {text ? parse(text) : text}
                </div>
              )}

              <div className="mb-4 flex items-center">
                <div className="flex-grow emoji-container flex items-center overflow-x-auto mr-2">
                  <EmojiContainer commentId={id} />
                </div>
                <div className="flex-none items-center">
                  {!!currUser && (
                    <>
                      <button
                        type="button"
                        className="hover:bg-gray-600 outline-none py-1 rounded-lg px-2 flex items-center text-sm"
                        onClick={() => setShowEmojiMart(!showEmojiMart)}
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <span className="ml-1">+</span>
                      </button>
                      <div className="relative w-full">
                        {showEmojiMart && (
                          <OutsideClickAlerter
                            handler={() => setShowEmojiMart(false)}
                          >
                            <Picker
                              style={{
                                position: "absolute",
                                right: "-50px",
                                marginTop: "10px",
                                zIndex: 9999,
                              }}
                              emojiTooltip
                              set="apple"
                              onSelect={addEmoji}
                              title=""
                              autoFocus
                              // theme="dark"
                            />
                          </OutsideClickAlerter>
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className="flex-none items-center">
                  {!!currUser && (
                    <button
                      className="flex flex-none items-center text-sm px-2 py-1 rounded-md hover:bg-gray-500"
                      type="button"
                      onClick={() => setReplyOpen(!replyOpen)}
                    >
                      Reply
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="flex w-full border-t border-gray-500 py-2">
          <div className="flex w-full px-2">
            <button
              type="button"
              onClick={() => setReplyListOpen(!replyListOpen)}
              className="flex-none text-sm px-2 py-1 rounded-md hover:bg-gray-500"
            >
              {replies.length || "No"}{" "}
              {replies.length === 1 ? "reply" : "replies"}
            </button>
            <div className="flex-grow"> </div>
            {!!currUser && (
              <button
                className="flex flex-none items-center ml-3 text-sm px-2 py-1 rounded-md hover:bg-gray-500"
                type="button"
                onClick={() => setReplyOpen(!replyOpen)}
              >
                <ChatIcon className="w-5 h-5 text-white mr-1" />
                Reply
              </button>
            )}
          </div>
        </div> */}

        {replyListOpen && <ReplyList replies={replies} commentId={id} />}
      </div>
    </div>
  );
};
